import React from 'react'
import { Grid, Image, Wrapper, H, P } from '@farewill/ui'

const Cards = () => {
  const CardsData = [
    {
      id: 'listen-to',
      title: 'We arrange the cremation',
      image: '/illustrations/funeral-coordinator',
      content: (
        <P>
          Wherever you are in England and Wales, we’ll bring your loved one to
          our chapel of rest. Then complete all the paperwork and arrange the
          cremation.
        </P>
      ),
    },
    {
      id: 'do-admin',
      title: 'On the day',
      image: '/illustrations/chapel-of-rest',
      content: (
        <P>
          We’ll transport them to a local crematorium and carry out a cremation
          you don’t attend. We’re always available if you need a chat.
        </P>
      ),
    },
    {
      id: 'make-sure',
      title: 'We hand-deliver the ashes',
      image: '/illustrations/direct-cremation',
      content: (
        <P>
          We deliver your loved one’s ashes in your choice of urn, or scatter
          them for you. We can also give ideas and advice on arranging a fitting
          send-off.
        </P>
      ),
    },
  ]

  return (
    <Grid>
      {CardsData.map((data) => (
        <Grid.Item
          key={data.id}
          spanFromM={10}
          startColumnFromM={2}
          spanFromL={4}
          startColumnFromL="auto"
        >
          <Wrapper paddingFromM={['M', 0]} paddingFromL={[0]}>
            <Wrapper style={{ height: 200 }} margin={[0, 0, 'M']} centered>
              <Image path={data.image} width={200} style={{ height: '100%' }} />
            </Wrapper>

            <H size="S">{data.title}</H>
            {data.content}
          </Wrapper>
        </Grid.Item>
      ))}
    </Grid>
  )
}

export default Cards
